
let lib = {}

lib.camelize = (str) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

lib.isHover = (el, mouse) => {
    if(!el){
        return false
    }

    function getPositions(elem) {

        const pos = el.getBoundingClientRect();

        return [[pos.left, pos.right], [pos.top, pos.bottom]];
    }

    function comparePositions(p1, p2) {
        var r1, r2;
        r1 = p1[0] < p2[0] ? p1 : p2;
        r2 = p1[0] < p2[0] ? p2 : p1;
        return r1[1] > r2[0] || r1[0] === r2[0];
    }

    var pos1 = getPositions(el),
        pos2 = [[mouse.pageX, mouse.pageX], [mouse.pageY, mouse.pageY]];
    return comparePositions(pos1[0], pos2[0]) && comparePositions(pos1[1], pos2[1]);


}

lib.addClass = (e, cs) => {


    if (!Array.isArray(cs)) {
        cs = [cs]
    }
    for (let c of cs) {
        e.classList.add(c)
    }
    return false
}
lib.apc = (p, c) => {

    if (!Array.isArray(c)) {
        c = [c]
    }
    for (let e of c) {
        p.appendChild(e)
    }
    return false

}
lib.updateElement = (el, opt) => {
    try {
        if (opt.id) {
            el.id = opt.id
        }

        for (let o in opt.style) {
            el.style[lib.camelize(o)] = opt.style[o]


        }
        for (let o of opt.class) {

            el.classList.add(o)

        }
        if (opt.text) {
            el.textContent = opt.text
        }

    } catch (e) {

    }

    return false

}
lib.build = (e, opt) => {
    const el = document.createElement(e)
    try {
        if (opt.id) {
            el.id = opt.id
        }

        for (let o in opt.style) {
            el.style[lib.camelize(o)] = opt.class[o]


        }
        for (let o of opt.class) {

            el.classList.add(o)

        }
        if (opt.text) {
            el.innerText = opt.text
        }
        for( let c of opt.child){
           el.appendChild(c)
        }
  
    } catch (e) {

    }

    return el
}
lib.qs = (e, parent = document) => {
    if (!e || e === '#' || e === '.' || /^[.#]$/.test(e)) return null
    try {
        return parent.querySelector(e)
    } catch (err) {
        return null
    }
}
lib.qsa = (e, parent = document) => {
    if (!e || e === '#' || e === '.' || /^[.#]$/.test(e)) return []
    try {
        return parent.querySelectorAll(e)
    } catch (err) {
        return []
    }
}
lib.txt = (e) => {
    return document.createTextNode(e)
}

lib.toSlug = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    const to = "aaaaeeeeiiiioooouuuunc------";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
lib.accept = async (message) => {
    return new Promise((resolve, reject) => {
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        holder.classList.add('modal')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt('confirm')
        const cancelmsg = lib.txt('cancel')
        const ok = lib.build('button')
        ok.appendChild(confmsg)
        const cancel = lib.build('button')
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const h1 = lib.build('h1')

        const msg = lib.txt(message)
        h1.appendChild(msg)
        header.appendChild(h1)

        footer.appendChild(ok)
        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()

            return resolve(true)


        })
        cancel.addEventListener('click', () => {
            clean()
            return resolve(false)
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
    })

}




lib.midilearn = async (mode="") => {
    return new Promise((resolve, reject) => {

        //console.log("midilearn")
        window.modalopen = true
        const holder = lib.build('div', { class: ['midimodal'] })
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        holder.classList.add('modal')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt('confirm')
        const cancelmsg = lib.txt('cancel')

        const cancel = lib.build('button')
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const h1 = lib.build('h1')

        const msg = lib.txt('turn knob on your midi controler to link')
        h1.appendChild(msg)
        header.appendChild(h1)


        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)

        cancel.addEventListener('click', () => {
            clean()
            return resolve(false)
        })
        function clean() {
            holder.parentNode.removeChild(holder);
            window.modalopen = false
        }
        lib.qs('body').appendChild(holder)
        holder.addEventListener('close', () => {
            clean()
            return resolve()
        })
    })

}


lib.midisettings = async (mode="") => {
    return new Promise((resolve, reject) => {

        //console.log("midilearn")
        window.modalopen = true
        const holder = lib.build('div', { class: ['midimodal'] })
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        holder.classList.add('modal')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        const body2 = lib.build('div')
        body2.classList.add('modal_body')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')

        const refreshmsg = lib.txt('refresh midi')
        const cancelmsg = lib.txt('save')

        const refresh = lib.build('button')
        const cancel = lib.build('button')
        refresh.appendChild(refreshmsg)
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const h1 = lib.build('h1')

        const msg = lib.txt('Midi Settings')

        // add a select to body that let user select root octave of keyboard


        const label = lib.build('label')
        label.innerText = "root octave"
        const select = lib.build('select')

        for(let i=0;i<10;i++){

            const opt = lib.build('option')
            opt.value = i
            opt.innerText = "c"+i
            select.appendChild(opt)
        }
    


        h1.appendChild(msg)
        header.appendChild(h1)

        footer.appendChild(refresh)
        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body2)
        form.appendChild(body)
        form.appendChild(footer)


        select.value = window.rootoctave

        select.addEventListener('change',()=>{
            window.rootoctave = select.value

            // save to localstorage
            localStorage.setItem('rootoctave',window.rootoctave)
        })
        const selectwrapper= lib.build('div')
        selectwrapper.classList.add('selectwrapper')
       
        body2.appendChild(selectwrapper)
        selectwrapper.appendChild(label)
        selectwrapper.appendChild(select)




        // for each midi inputs window.midiaccess.inputs crate a link in body 
        // link should contain name of input and a on off switch and select of midi channel

        // it's a MIDIInputMap

        // for(let i of window.midiaccess.inputs){


        //     if(!window.midisettings[i[1].id]){
        //         continue
        //     }
        //     console.log(i)
        //     const input = lib.build('div', {class:['midisetting']})
        //     const name = lib.build('div', {class:['midiname']})
        //     const onoff = lib.build('div', {class:['midionoff','icons2']})
        //     const channel = lib.build('div', {class:['midichannel']})
        
           
           
        //     name.innerText = i[1].name
        //   //  const inputonoff = lib.build('div')
          
        //     const inputchannel = lib.build('select')
        //     const omni= lib.build('option')
        //     omni.value="omni"
        //     omni.appendChild(lib.txt("omni"))
        //     inputchannel.appendChild(omni)
        //     for(let i=0; i<16; i++){
        //         const option = lib.build('option')
        //         option.value=i
        //         option.appendChild(lib.txt(`ch ${i+1}`))
        //         inputchannel.appendChild(option)
        //     }
           
        // inputchannel.value=window.midisettings[i[1].id].channel
          
        //   //  onoff.appendChild(inputonoff)
        //     if(window.midisettings[i[1].id].active){
        //         onoff.classList.add('active')
        //         onoff.innerHTML=""
        //     }else{
        //         onoff.classList.remove('active')
        //         onoff.innerHTML=""
        //     }
        //     onoff.addEventListener('click', ()=>{
        //         if(onoff.classList.contains('active')){
        //             onoff.classList.remove('active')
        //             window.midisettings[i[1].id].active = false
        //             onoff.innerHTML=""
        //         }else{
        //             onoff.classList.add('active')
        //             window.midisettings[i[1].id].active = true
        //             onoff.innerHTML=""
        //         }
        //     })

        //     inputchannel.addEventListener('change', ()=>{
        //         window.midisettings[i[1].id].channel = inputchannel.value
        //     })

        //     channel.appendChild(inputchannel)
        //     input.appendChild(name)
        //     input.appendChild(onoff)
        //     input.appendChild(channel)
        //     body.appendChild(input)
        // }
        function refreshmidi(){
            body.innerHTML=""
                for(let i of window.midiaccess.inputs){
        
        
                    if(!window.midisettings[i[1].id]){
                        continue
                    }
                    const input = lib.build('div', {class:['midisetting']})
                    const name = lib.build('div', {class:['midiname']})
                    const onoff = lib.build('div', {class:['midionoff','icons2']})
                    const channel = lib.build('div', {class:['midichannel']})
                
                   
                   
                    name.innerText = i[1].name
                  //  const inputonoff = lib.build('div')
                  
                    const inputchannel = lib.build('select')
                    const omni= lib.build('option')
                    omni.value="omni"
                    omni.appendChild(lib.txt("omni"))
                    inputchannel.appendChild(omni)
                    for(let i=0; i<16; i++){
                        const option = lib.build('option')
                        option.value=i
                        option.appendChild(lib.txt(`ch ${i+1}`))
                        inputchannel.appendChild(option)
                    }
                   
                inputchannel.value=window.midisettings[i[1].id].channel
                  
                  //  onoff.appendChild(inputonoff)
                    if(window.midisettings[i[1].id].active){
                        onoff.classList.add('active')
                        onoff.innerHTML=""
                    }else{
                        onoff.classList.remove('active')
                        onoff.innerHTML=""
                    }
                    onoff.addEventListener('click', ()=>{
                        if(onoff.classList.contains('active')){
                            onoff.classList.remove('active')
                            window.midisettings[i[1].id].active = false
                            onoff.innerHTML=""
                        }else{
                            onoff.classList.add('active')
                            window.midisettings[i[1].id].active = true
                            onoff.innerHTML=""
                        }
                    })
        
                    inputchannel.addEventListener('change', ()=>{
                        window.midisettings[i[1].id].channel = inputchannel.value
                    })
        
                    channel.appendChild(inputchannel)
                    input.appendChild(name)
                    input.appendChild(onoff)
                    input.appendChild(channel)
                    body.appendChild(input)
                }
        
        }    
           
        
       
        refresh.addEventListener('click', ()=>{

         document.body.dispatchEvent(new CustomEvent('midirefresh', { detail: {}}))   
         setTimeout(()=>{
            refreshmidi()
            }, 500)
        })

        cancel.addEventListener('click', () => {
            clean()
            return resolve(false)
        })
        function clean() {
            holder.parentNode.removeChild(holder);
            window.modalopen = false
        }
        lib.qs('body').appendChild(holder)
        holder.addEventListener('close', () => {
            clean()
            return resolve()
        })

        refreshmidi()





    })

}


lib.prompter = async (message, confirmLabel = 'create', defaultValue = '') => {
    return new Promise((resolve, reject) => {
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper', 'modal_wrapper--prompt')
        holder.classList.add('modal', 'modal--prompt')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt(confirmLabel)
        const cancelmsg = lib.txt('cancel')
        const ok = lib.build('button')
        ok.appendChild(confmsg)
        const cancel = lib.build('button')
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const msg = lib.txt(message)
        header.appendChild(msg)
        const input = lib.build('input')
        input.placeholder = 'name'
        input.value = defaultValue
        body.appendChild(input)
        footer.appendChild(ok)
        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()
            if (input.value.trim() != '') {
                return resolve(input.value)
            } else {
                return reject()
            }

        })
        cancel.addEventListener('click', () => {
            clean()
            return reject()
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
        if (defaultValue) input.select()
        else input.focus()
    })

}
lib.rename = async (data) => {
    return new Promise((resolve, reject) => {
        const message = data.message
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        holder.classList.add('modal')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt('create')
        const cancelmsg = lib.txt('cancel')
        const ok = lib.build('button')
        ok.appendChild(confmsg)
        const cancel = lib.build('button')
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const msg = lib.txt(message)
        header.appendChild(msg)
        const input = lib.build('input')
        input.value = data.value
        //input.placeholder = 'name'
        body.appendChild(input)
        footer.appendChild(ok)
        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()
            if (input.value.trim() != '') {
                return resolve(input.value)
            } else {
                return reject()
            }

        })
        cancel.addEventListener('click', () => {
            clean()
            return reject()
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
    })

}
lib.alertmessage = async (message) => {
    return new Promise((resolve, reject) => {
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        form.classList.add('modal_wrapper--alert')
        holder.classList.add('modal')
        holder.classList.add('modal--alert')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt('confirm')

        const ok = lib.build('button')
        ok.appendChild(confmsg)

        holder.appendChild(form)
        const h1 = lib.build('h1')
        h1.appendChild(lib.txt('Notice'))
        header.appendChild(h1)

        const msg = lib.build('p')
        msg.appendChild(lib.txt(message))
        body.appendChild(msg)

        footer.appendChild(ok)

        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()

            return resolve(true)
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
    })

}

lib.confirmmessage = async (message) => {
    return new Promise((resolve, reject) => {
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        form.classList.add('modal_wrapper--confirm')
        holder.classList.add('modal')
        holder.classList.add('modal--confirm')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')

        const ok = lib.build('button')
        ok.appendChild(lib.txt('confirm'))
        const cancel = lib.build('button')
        cancel.appendChild(lib.txt('cancel'))

        holder.appendChild(form)
        const h1 = lib.build('h1')
        h1.appendChild(lib.txt('Confirm'))
        header.appendChild(h1)

        const msg = lib.build('p')
        msg.appendChild(lib.txt(message))
        body.appendChild(msg)

        footer.appendChild(cancel)
        footer.appendChild(ok)

        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()
            return resolve(true)
        })
        cancel.addEventListener('click', () => {
            clean()
            return resolve(false)
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
    })
}

lib.prompPlaylist = async (data) => {


    return new Promise((resolve, reject) => {
        const holder = lib.build('div')
        const form = lib.build('div')
        form.classList.add('modal_wrapper')
        holder.classList.add('modal')
        const header = lib.build('div')
        header.classList.add('modal_header')
        const body = lib.build('div')
        body.classList.add('modal_body')
        const footer = lib.build('div')
        footer.classList.add('modal_footer')
        const confmsg = lib.txt('confirm')
        const cancelmsg = lib.txt('cancel')
        const ok = lib.build('button')
        ok.appendChild(confmsg)
        const cancel = lib.build('button')
        cancel.appendChild(cancelmsg)
        holder.appendChild(form)
        const h1 = lib.build('h1')
        const msg = lib.txt('playlist infos')
        h1.appendChild(msg)
        header.appendChild(h1)
        const input = lib.build('input')
        const description = lib.build('textarea')
        if (data) {
            input.value = data.name
            description.value = data.description
        }
        input.placeholder = 'playlist name'
        description.placeholder = "description"
        body.appendChild(input)

        body.appendChild(description)
        footer.appendChild(ok)
        footer.appendChild(cancel)
        form.appendChild(header)
        form.appendChild(body)
        form.appendChild(footer)
        ok.addEventListener('click', () => {
            clean()
            if (input.value.trim() != '') {
                return resolve({
                    name: input.value,
                    description: description.value
                }
                )
            } else {
                return reject()
            }

        })
        cancel.addEventListener('click', () => {
            clean()
            return reject()
        })
        function clean() {
            holder.parentNode.removeChild(holder);
        }
        lib.qs('body').appendChild(holder)
    })

}

lib.toHHMMSS = function (sec) {
    const sec_num = parseInt(sec, 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
}
lib.hhmmssToSecond = (hms) => {
    const a = hms.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    return Number(seconds)
}

lib.formatBytes=(bytes, decimals)=> {
    if (bytes === 0) return '0 GB'
    if (isNaN(parseInt(bytes))) return bytes
    if (typeof bytes === 'string') bytes = parseInt(bytes)
    if (bytes === 0) return '0'
    const k = 1000
    const dm = decimals + 1 || 3
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}

lib.sec2time=(timeInSeconds)=> {
    const pad = (num, size) => { return ('000' + num).slice(size * -1); },
        time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60),
        milliseconds = time.slice(-3);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + '.' + pad(milliseconds, 3);
}

module.exports = lib